import styled from '@emotion/styled';

export const Expander = styled.div({
  display: 'flex',
  justifyContent: 'center',
  cursor: 'pointer',
});
